import kindFields from './groupFields/kindFields'
import inquiryFields from './groupFields/inquiryFields'
import feedbackFields from './groupFields/feedbackFields'
import pressFields from './groupFields/pressFields'
import supportFields from './groupFields/supportFields'
import contactFields from './groupFields/contactFields'

export default () => [
  kindFields(),
  feedbackFields(),
  inquiryFields(),
  pressFields(),
  supportFields(),
  contactFields(),
]
